export const AlphNumCharsValidator = (value, component) => {
	//  ^[ A-Za-z0-9_@./#&?+-]*$
	//  ^[-@.,'()$!?/%*#&+\w\s]*$

	var str = /^[-@.,'()$!?/%*#&+\w\s]*$/g;
	var patt = str;

	return patt.test(value);

}



// WEBPACK FOOTER //
// ./resources/assets/js/validators/alpha-num-chars-validator.js